



























































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import JsBarcode from 'jsbarcode'
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { yun, Inquiry } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
// import Print from '../../common/util/print'
// import { fmoney } from '@/common/util/money';
// import { Print } from '@/common/util/print'
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        SearchPanel,
        collapse,
        ListFilterPanel,
        DraggerImg,
    },
})
export default class ordermanager extends Vue {
    public JsBarcode = JsBarcode
    public isDisabled: boolean = true;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public orderStatusEnum = enums.aacorderStatusEnum;
    public istState = enums.istState;
    public labelPosition: string = 'right';
    public can0: any = true;
    public can1: any = true;
    public canad: any = true;
    public can2: any = true;
    public can3: any = true;
    public expandType: boolean = false;
    public dayinLog:any = false
    public dayinValue:any = {}
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.creationStartTime = value[0];
            this.searchValue.creationEndTime = value[1];
        } else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
        }
    }
    statusArr: any = [];
    public searchValue: any = {
        interceptFlag: '',
        subOrderNo: '',
        shipOrderNo: '',
        deliveryOrderNo: '',
        carpoolFlag: '',
        closeFlag: '',
        code: '',
        belongCarrierName: '',
        consigneeName: '',
        originAddress: '',
        arrivalAddress: '',
        creationStartTime: '',
        creationEndTime: '',
        orderStatusList: ['7'],
        orderBy: '',
    };
    public dayinData:any = []
    public tableData: Array<type.CspInquiryListItem> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        daying: HTMLFormElement,
    };
    //根据权限判断按钮显隐
    public whyjsh3: boolean = false;
    public fhdz3: boolean = false;
    public fhds3: boolean = false;
    public fhdw3: boolean = false;
    public ww: any = 1920;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.whyjsh3 = webMenus.includes('whyjsh3');
        this.fhdz3 = webMenus.includes('fhdz3');
        this.fhds3 = webMenus.includes('fhds3');
        this.fhdw3 = webMenus.includes('fhdw3');
        this.ww = document.documentElement.clientWidth;
    }
    public mounted() {
        if (sessionStorage.getItem('orderacceptmanager_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('orderacceptmanager_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            if (this.searchValue.statusListStr) {
                this.statusArr = this.searchValue.statusListStr.split(',');
            }

            this.searchPagin = sessionStorage.getItem('orderacceptmanager_page')
                ? JSON.parse(sessionStorage.getItem('orderacceptmanager_page'))
                : this.searchPagin;
            this.getInquiryList();
        } else {
            this.searchPagin = sessionStorage.getItem('orderacceptmanager_page')
                ? JSON.parse(sessionStorage.getItem('orderacceptmanager_page'))
                : this.searchPagin;
            this.getInquiryList();
        }
    }

    async querySearchAsynccc(queryString, cb) {
        var res = await yun.GetCarrierList({ name: queryString, count: 30 });
        var restaurants = [];
        if (res) {
            res.data.forEach((item) => {
                restaurants.push({
                    value: item.name,
                });
            });
            cb(restaurants);
        }
    }
    async querySearchAsyCustomerName(queryString, cb){
            let res = await yun.ShipperGetList({
                name: queryString,
                type: 1,
                count: 30,
            });
            let dds = [];
            if (res) {
                res.forEach((item) => {
                    dds.push({
                        id:item.id,
                        customerBaseCode: item.customerBaseCode,
                        value: item.customerBaseName,
                    });
                });
                cb(dds);
            }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'orderStatus':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'subOrderNo':
            {
                this.searchValue.orderBy = '2';
            }
                break;
            case 'consigneeName':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'latestDeliveryTime':
            {
                this.searchValue.orderBy = '4';
            }
                break;
            case 'creationTime':
            {
                this.searchValue.orderBy = '5';
            }
                break;
            // case 'carriageWayStr':
            // {
            //     this.searchValue.orderBy = '7';
            // }
            //     break;
        }
        this.getInquiryList();
    }

    public toOrder(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 1;
        this.dialogConfig = {
            title: '终结该发货计划',
            show: true,
        };
    }
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        if (this.btt == 3) {
            yun.deleteOrder(this.ssid).then(() => {
                this.$message.success('发货计划删除成功');
                this.getInquiryList();
            });
        } else if (this.btt == 1) {
            yun.IupdateOrderStatus({ id: this.ssid, orderStatus: 5 }).then(() => {
                this.$message.success('发货计划终结成功');
                this.getInquiryList();
            });
        } else if (this.btt == 2) {
            yun.IupdateOrderStatus({ id: this.ssid.id, status: 4 }).then(() => {
                this.$message.success('完成该发货计划成功');
                this.getInquiryList();
            });
        }
        this.dialogConfig = {
            show: false,
        };
    }
    public btt: any = 0;
    public ssid: any = '';
    public toEdit(data) {
        this.$router.push({
            path: '/addOrder',
            query: {
                id: data.id,
                type: 'edit',
            },
        });
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public async exportExcel() {
        let data = await yun.exportOrder(this.searchValue);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }
    public async exportExcel1() {
        let data = await yun.GetOrderTemplate(this.searchValue);
    }
    public getInquiryList() {
        this.loading = true;
        this.searchValue.statusListStr = this.statusArr.join();
        yun.getNetworkFreightList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                console.log('this.searchPagin.currentPage', this.searchPagin.currentPage, this.searchPagin.count);
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        sessionStorage.setItem('orderacceptmanager_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
        this.toggleSelection()
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('orderacceptmanager_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        this.$router.push({
            path: '/orderAccept',
            query: {
                id: item,
                type: 'detail',
            },
        });
    }
    public viewInquiry1(item) {
        this.$router.push({
            path: '/orderpays',
            query: {
                id: item,
                type: 'detail',
            },
        });
    }

    @Watch('tableData')
    handleListDataChange() {
        let tempSelected = JSON.parse(JSON.stringify(this.selectionRow));
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        console.log('this.selectionRow', this.selectionRow);
        this.selectedPreExisting(tempSelected);
        // 以下两行勿删 切换bug
    }
    selectedPreExisting(rows) {
        // let tempSelected = JSON.parse(JSON.stringify(this.selectionRow))
        // let refsElTable = this.$refs.multipleTable as any // 获取表格对象
        // this.$nextTick(() => {tempSelected.forEach(v=>refsElTable.toggleRowSelection(v))});
        // this.$nextTick(() => {tempSelected.forEach(v=>refsElTable.toggleRowSelection(v))});
        if (this.selectionRow.length > 0) {
            let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
            //这里使用this.$nextTick是防止表格未渲染完成就执行，导致无法添加选中效果
            this.$nextTick(() => {
                this.selectionRow.forEach((row) => {
                    //判断row是存在当前tableData
                    this.tableData.forEach((data) => {
                        if (data.id == row.id) {
                            console.log('id', data.id);

                            refsElTable.toggleRowSelection(data, true);
                        }
                    });
                    // let selectedItem = this.tableData.find(item => item.code == row.code)
                    // console.log(selectedItem)
                });
                this.$refs.multipleTable.$forceUpdate();
            });
            console.log('this.selectionRow333', this.ss1, this.ss1.length, this.selectionRow);
        } else {
            this.$refs.multipleTable.clearSelection();
        }
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    public ss1: any = [];
    handleSelectionChange(rows) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象

        console.log('3334444', rows);
        this.selectionRow = rows; //保存已选择行
        this.ss1 = [];
        this.can0 = true;
        this.can1 = true;
        this.can2 = true;
        this.can3 = true;
        this.canad = true;

        if (rows.length > 1) {
            this.can1 = false;
            this.can0 = false;
            this.can2 = false;
            this.canad = false;
        } else {
            this.can3 = false;
            if (rows[0].statusStr !== '待发布') {
                this.can1 = false;
                this.can2 = false;
                this.can0 = false;
            }
            if (rows[0].transInquiryId == null) {
                this.can0 = false;
            }
            if (rows[0].statusStr == '发运中' && rows[0].shipmentType == 3) {
                this.can1 = true;
            }
        }
        let isall = false;
        this.selectionRow.forEach((data) => {
            if (data.primaryDeptName != rows[0].primaryDeptName) {
                this.can3 = false;
            }
            if (data.carriageWayStr != rows[0].carriageWayStr) {
                this.can3 = false;
            }
            if (data.statusStr != '待发布') {
                this.can3 = false;
            }
        });
        if (isall) {
            return;
        }
        // this.selectionRow.forEach(row=> {
        //     if (row.statusStr == '待接单' ||row.statusStr == '发运中')  {
        //         // this.addRows(row)
        //     } else {
        //         refsElTable.toggleRowSelection(row); // 调用选中行方法
        //         this.$alert('只有待接单和发运中状态下的订单才能派车')
        //     }
        // })
        // for (var i = 0; i < rows.length; i++) {
        //     if (rows[i].feeStatus == '待接单' || rows[i].feeStatus == '发运中') {
        //         this.ss1.push(rows[i].id)
        //     }
        // }
        // let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        // let isAll = true
        //  if (rows.forEach(row => {
        //      if (row.statusStr == '待接单' ||row.statusStr == '发运中')  {
        //      } else {
        //          isAll = false
        //      }
        //  }))
        // if (isAll) {
        //     this.$alert('只有待接单和发运中状态下的订单才能派车')
        //     return
        // }
        // this.selectionRow = rows; //保存已选择行
        // this.ss1 = this.selectionRow.concat();
        if (rows.length) {
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
        }
    }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type) {
        if (row.orderStatus == '待发布' || row.orderStatus == '待接单'|| row.orderStatus == '审核中' || row.orderStatus == '审核退回'  || row.orderStatus == '已终结') {
            this.$router.push({
                path: '/orderDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                    from: 'orderAcceptManager',
                },
            });
        } else {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        }
    }
    copAdd() {
        if (this.selectionRow.length != 0) {
            this.$router.push({
                path: '/addOrder',
                query: {
                    type: 'copy',
                    id: this.selectionRow[0].id,
                },
            });
        } else {
            this.$router.push({
                path: '/addOrder',
                query: {},
            });
        }
    }

    public handleDelete(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 3;
        this.dialogConfig = {
            title: '删除该发货计划',
            show: true,
        };
    }
    public handleFinal(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 1;
        this.dialogConfig = {
            title: '终结该发货计划',
            show: true,
        };
    }
    async toend(data) {
        this.ssid = '';
        this.ssid = data;
        this.btt = 2;
        this.dialogConfig = {
            title: '完成该发货计划',
            show: true,
        };
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'toEdit':
                this.toEdit(command.data);
                break;
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData =
        JSON.parse(localStorage.getItem('orderAcceptManager')) && JSON.parse(localStorage.getItem('orderAcceptManager')).length == 17
            ? JSON.parse(localStorage.getItem('orderAcceptManager'))
            : [
                { title: '计划状态', isShow: true, disabled: false },
                { title: '计划编号', isShow: true, disabled: false },
                { title: '装运单号', isShow: true, disabled: false },
                { title: '发货地址', isShow: true, disabled: false },
                { title: '收货地址', isShow: true, disabled: false },
                { title: '收货方', isShow: true, disabled: false },
                { title: '客户单位', isShow: true, disabled: false },
                { title: '子单号', isShow: true, disabled: false },
                { title: '客户/基地名称', isShow: true, disabled: false },
                { title: '车队名称', isShow: true, disabled: false },
                { title: '拼车标识', isShow: true, disabled: false },
                { title: '关单标识', isShow: true, disabled: false },
                { title: '截单标识', isShow: true, disabled: false },
                { title: '订单类型', isShow: true, disabled: false },
                { title: '装运单类型', isShow: true, disabled: false },
                { title: '交货单号', isShow: true, disabled: false },
                { title: '最晚发货时间', isShow: true, disabled: false },
                { title: '订单时间', isShow: true, disabled: false },
              ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('orderAcceptManager', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
            interceptFlag: '',
            subOrderNo: '',
            shipOrderNo: '',
            deliveryOrderNo: '',
            carpoolFlag: '',
            closeFlag: '',
            code: '',
            belongCarrierName: '',
            consigneeName: '',
            originAddress: '',
            arrivalAddress: '',
            creationStartTime: '',
            creationEndTime: '',
            orderStatusList: ['7'],
            orderBy: '',
        };
        this.statusArr = [];
        this.timeList = [];
        this.searchFunc();
    }
    selectCar2(data) {
        this.searchValue.carrierId = data.id;
    }
    selectList;
    carrierName: any = '';
    async querySearch2(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    errList: any = [];
    batchImportList: any = [];
    errorType: any = '';
    handleClose() {
        this.dialogVisible = false;
    }
    dialogVisible: any = false;
    async updateImage(e: any) {
        this.errList = [];
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        let resd = await yun.uploadexcel(param);
        if (!resd.validity) {
            this.errorType = resd.validityStatus;
            if (this.errorType == 1) {
                if (resd.orderList.length == 0) {
                    this.$message.error('Excel表格为空，无法上传！');
                } else {
                    this.$message.error('一次最多上传100条订单，请删减后重新上传！');
                }
            }
            if (this.errorType == 2) {
                this.errList = [];
                this.errList = resd.errRowCellList;
                this.batchImportList = [];
                console.log('res.orderList' + JSON.stringify(resd.orderList));
                resd.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
                console.log('this.errList' + JSON.stringify(this.errList));
            } else if (this.errorType == 3) {
                this.errList = resd.repeatRow;
                this.batchImportList = [];
                resd.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
            }
        } else {
            let res = await yun.orderAddExce1Data({ orderList: resd.orderList });
            this.searchFunc();
            this.$message.success('导入成功!');
        }
    }
    ccdata: any = [];
    async listcc(data, expandedRows) {
        let res = await yun.pageSimpleList({ orderId: data.id, count: -1 });
        this.ccdata[data.id] = res.data;
        this.$refs.multipleTable.toggleRowExpansion();
        this.$refs.multipleTable.toggleRowExpansion();
    }
    toDetail1(row, type) {
        console.log('row', row);
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    types: 'ordermanager',
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    //orderId:row.orderList[0].id
                    orderId: row.id,
                    tab: 'second',
                    status: row.carrierOrderStatus,
                    //
                    // id: row.id,
                    // name: 'detail',
                    // orderCnt:row.orderList.length,
                    // orderId:row.orderList[0].id
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    id: row.id,
                    tab: 'third',
                    orderCnt: row.orderList.length,
                },
            });
        }
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待发货':
                return 'dfh';
            case '在途中':
                return 'ztz';
            case '已送达':
                return 'ysd';
            case '已终结':
                return 'yzj';

            default:
                break;
        }
    }
    cellClass({ row, column, rowIndex, columnIndex }) {
        let isr = false;
        this.errList.forEach((data) => {
            // console.log(columnIndex,rowIndex,data,data.cell,data.row-1,this.errList)
            if (columnIndex == data.cell && rowIndex == Number(data.row) - 1) {
                isr = true;
            } else {
            }
        });
        console.log(rowIndex, columnIndex, isr);
        if (isr) {
            return 'border: 2px dashed #f11;position: relative;top:-1px';
        } else {
            return '';
        }
        // for (let i = 0; i < .length; ) {
        //     console.log(columnIndex,rowIndex,i,this.errList[i].cell,Number(this.errList[i].row) - 1,this.errList)
        //
        //
        // }
    }
    getRowKey(row) {
        return row.id;
    }
    handleCancelSelect(data) {
        this.$refs.multipleTable.toggleRowSelection(data);
    }
    toggleSelection() {
        this.$refs.multipleTable.clearSelection();
    }
    flexColumnWidth(str, tableData, flag = 'max') {
        try {
            // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
            // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
            // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
            str = str + '';
            let columnContent = '';
            if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
                return '200px';
            }
            if (!str || !str.length || str.length === 0 || str === undefined) {
                return '200px';
            }
            if (flag === 'equal') {
                // 获取该列中第一个不为空的数据(内容)
                for (let i = 0; i < tableData.length; i++) {
                    if (tableData[i][str].length > 0) {
                        // console.log('该列数据[0]:', tableData[0][str])
                        columnContent = tableData[i][str];
                        break;
                    }
                }
            } else {
                let index = 0;
                for (let i = 0; i < tableData.length; i++) {
                    if (tableData[i][str] === null) {
                        return '150px';
                    }
                    const now_temp = tableData[i][str] + '';
                    const max_temp = tableData[index][str] + '';
                    if (now_temp.length > max_temp.length) {
                        index = i;
                    }
                }
                columnContent = tableData[index][str];
            }
            console.log(str, columnContent);
            // console.log('该列数据[i]:', columnContent)
            // 以下分配的单位长度可根据实际需求进行调整
            let flexWidth = 0;
            for (const char of columnContent) {
                if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                    // 如果是英文字符，为字符分配8个单位宽度
                    flexWidth += 9;
                } else if (char >= '\u4e00' && char <= '\u9fa5') {
                    // 如果是中文字符，为字符分配15个单位宽度
                    flexWidth += 14;
                }else if(/[^a-zA-Z0-9]/.test(char)){
                    flexWidth += 14;
                } else {
                    // 其他种类字符，为字符分配8个单位宽度
                    flexWidth += 10;
                }
            }
            if (str == 'consigneePhone') {
                flexWidth = flexWidth * 2;
            }
            if (flexWidth < 120) {
                // 设置最小宽度
                flexWidth = 150;
            }
            // if (flexWidth > 250) {
            //   // 设置最大宽度
            //   flexWidth = 250
            // }
            return flexWidth + 20 + 'px';
        } catch (e) {
            console.log('error', e);
            return '160px';
        }
    }
    copAdd1(data) {
        let isall = false;
        this.selectionRow.forEach((data) => {
            if (data.primaryDeptName != this.selectionRow[0].primaryDeptName) {
                isall = true;
                this.$alert('发货单位不同不能并单');
            }
        });
        if (isall) {
            return;
        }
        this.selectionRow.forEach((row) => {
            if (row.statusStr == '待发布' || row.statusStr == '发运中') {
                // this.addRows(row)
            } else {
                this.$alert('只有待发布和发运中状态下的发货计划才能发布运单');
                isall = true;
                return;
            }
        });
        if (isall) {
            return;
        }
        console.log('selectionRow', this.selectionRow);
        if (data == 1) {
            if (this.selectionRow.length > 1) {
                this.$alert('只能选中一条订单进行直接发运');
            } else {
                this.$router.push({
                    path: '/orderDetailEng',
                    query: {
                        id: this.selectionRow[0].id,
                        showHd: 'false',
                    },
                });
            }
        } else if (data == 2) {
            if (this.selectionRow.length > 1) {
                let ids = '';
                this.selectionRow.forEach((data) => {
                    ids = ids + data.id + ',';
                });
                this.$router.push({
                    path: '/orderDetailMore',
                    query: {
                        ids: ids,
                    },
                });
            } else {
                this.$router.push({
                    path: '/orderDetailEng',
                    query: {
                        id: this.selectionRow[0].id,
                        showHd: 'false',
                    },
                });
            }
        } else if (data == 3) {
            this.$router.push({
                path: '/oneMoreOrderDetail',
                query: {
                    id: this.selectionRow[0].id,
                    showHd: 'false',
                },
            });
        }
    }
    public dayin(){
        this.dayinLog = true
        setTimeout(_=> {
            this.JsBarcode("#orderCode", "080128984610007002843031",{ fontSize:14, });
        })
    }
    public dayinLogClose() {
        this.dayinLog = false
    }
    // public Print:any = Print
}
